const apispreadsheets = 'https://opensheet.elk.sh/1M1uaegvEMvVCZIcmcMFtse0rdX2sSfXguisvMBOpyss';

// Translate Google Drive link to streamable link
const imgFromDriveUrl = (url) => url.replace('file/d/', 'thumbnail?id=').replace('/view?usp=sharing', '&sz=w500');


export { apispreadsheets, imgFromDriveUrl };
